<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type="primary" @click="save" :loading="btnLoading" v-if="disabled">保存</el-button>
      <vxe-button type="primary" v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="psu" label-position="right" class="mainfrom">
        <div class="split-box">
          <div class="split-line"></div>
          <div class="split-name">【缴费信息】</div>
        </div>
        <div class="row">
          <el-form-item label="项目编号" class="from-value">
            {{psu.projectcode}}
          </el-form-item>
          <el-form-item label="项目名称" class="from-value">
            {{psu.projectname}}
          </el-form-item>
        </div>
        <el-form-item label="供应商" class="from-value">
          {{psu.comfullname}}
        </el-form-item>
        <!-- <el-form-item label="电子合同" class="from-value">
            <span style="color: #2f74ff;cursor: pointer;"
                      @click="downFile(append.appendurl)" v-if="append">
                    <a :src="$store.getters.uploadAddr + append.appendurl">{{append.appendfilename}}</a>
                  </span>
        </el-form-item> -->
        <el-form-item label="成交金额" class="from-value">
          ￥{{setThousand(psu.psuamt)}}元
        </el-form-item>
        <el-form-item label="计划代理服务费" class="from-value">
          ￥{{setThousand(psu.psufeeamt)}}元
        </el-form-item>
        <el-form-item label="实际代理服务费" class="from-value">
          ￥{{setThousand(psu.psuconfirmfeeamt)}}元
        </el-form-item>
        <el-form-item label="是否已支付" class="from-value">
          {{psu.psufewreceive===1?'已支付':psu.psufeepayuserid? '已支付':'未支付'}}
        </el-form-item>
        <el-form-item label="支付人" class="from-value" v-if="psu.check">
          {{psu.psufeepayusername?psu.psufeepayusername:psu.psufeecheckusername}}
        </el-form-item>
        <el-form-item label="支付时间" class="from-value" v-if="psu.check">
          {{psu.psufeepaytime | newDate}}
        </el-form-item>
        <el-form-item label="支付凭证" v-if="psu.psufeepayurl">
          <popover-img v-if="psu.psufeepayurl" :img-src="psu.psufeepayurl ? $store.getters.uploadAddr + psu.psufeepayurl:''"
                       default-height="150" after-height="400"></popover-img>
        </el-form-item>
        <el-form-item label="交易单号" class="from-value" v-if="psu.psufeepaytradeno">
          {{psu.psufeepaytradeno}}
        </el-form-item>
        <div v-if="psu.psufewreceive">
          <el-form-item label="收款状态" class="from-value" >
            {{+psu.psufewreceive===1?'已收':'未收'}}
          </el-form-item>
          <el-form-item label="收款人" class="from-value" >
            <div v-if="+psu.psufeepaytype === 1 || +psu.psufeepaytype === 2">
              线上支付
            </div>
            <div v-else>
              {{psu.psufewreceivername}}
            </div>
          </el-form-item>
          <el-form-item label="收款时间" class="from-value" >
            {{psu.psufewreceivetime | newDate}}
          </el-form-item>
        </div>
        <div class="split-box">
          <div class="split-line"></div>
          <div class="split-name">【开票信息】</div>
        </div>
        <el-form-item label="报名联系人" class="from-value">
            {{psu.psucontactname}}
        </el-form-item>
        <el-form-item label="报名电话" class="from-value">
            {{psu.psucontactphone}}
        </el-form-item>
        <el-form-item label="单位电话" class="from-value">
            {{psu.comtel}}
        </el-form-item>
        <el-form-item label="联系邮箱" class="from-value">
            {{psu.psucontactmail}}
        </el-form-item>
        <el-form-item label="发票类型" class="from-value">
          {{+psu.psufwfinvoice === 1 ? '增值税普通':+psu.psufwfinvoice === 2?'增值税专用':''}}
        </el-form-item>
        <el-form-item label="信用代码" class="from-value">
            {{psu.comidcode}}
        </el-form-item>
        <el-form-item label="单位地址" class="from-value">
            {{psu.comaddr}}
        </el-form-item>
        <el-form-item label="开户银行" class="from-value">
            {{psu.combank}}
        </el-form-item>
        <el-form-item label="开户账号" class="from-value">
            {{psu.combanknumber}}
        </el-form-item>
        <el-form-item label="开票申请备注" class="from-value">
            {{psu.psuInvoicmark}}
        </el-form-item>
        <div v-if="psu.psufewreceive">
          <div class="split-box">
            <div class="split-line"></div>
            <div class="split-name">【发票登记】</div>
          </div>
          <el-form-item label="发票号" class="from-value">
            <span>{{psu.psufwfinvoicenum}}</span> <el-button @click="changekpflg" type='primary' style="margin-left:30px;">登记</el-button>
          </el-form-item>
          <div>
            <el-form-item label="开票人" class="from-value" v-if="psu.fwfinvoicerusername">
                {{psu.fwfinvoicerusername}}
            </el-form-item>
            <el-form-item label="开票时间" class="from-value" v-if="psu.psufwfinvoicetime">
                {{psu.psufwfinvoicetime | newDate}}
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import popoverImg from '../common/popoverImg'
  import common from '@/mixin/common'
  import _ from 'lodash'
  export default {
    name: "jfckFrom",
    mixins: [common],
    data () {
      return {
        btnLoading: false,
        disabled:this.$route.params.form.psuconfirmfeeuserid ?  false:true ,
        psu: {},
        psufwfinvoicenum:'',
        kpflg:false,
        psuid:'',
        radio:3,
        append:{}
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getFwfInfo()
      this.getAppend()
    },
    watch: {},
    filters: {
      newDate (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      }
    },
    components: {uploadPicOne, popoverImg},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.psu = {}
        this.psufwfinvoicenum = ''
        this.kpflg = false
        this.psuid = this.$route.params.form.psuid
        this.disabled = this.$route.params.form.psuconfirmfeeuserid ? false:true,
        this.btnLoading = false
        this.psu.time = this.psu.psufeepaytime?this.psu.psufeepaytime:this.psu.psufeechecktime
      },
      async getAppend(){
          let res = await request({
            method:'get',
            url:'ywgl/append/getAppendListByFromId',
            params:{appendfromid:this.$route.params.form.psuid,appendfromtype:21}
          })
          this.append = res[0]
      },
      async getFwfInfo(){
        let res = await request({
          method: 'get',
          url: '/cwgl/psuFwf/getFwffeeInfo',
          params: {psuid: this.$route.params.form.psuid}
        })
        this.psu = res[0]
        this.psufwfinvoicenum = this.psu.psufwfinvoicenum
        if(this.psu.psufeepayuserid || this.psu.psufeecheckuserid){
          this.psu.check = true
        }
      },
      async changekpflg(){
        this.kpflg = true
      },
      async confirminvoice(){
        let form = {}
        form.userid = this.$store.getters.loginUser.userid
        form.psuid = this.psu.psuid
        form.psufwfinvoicenum = this.psufwfinvoicenum
        this.loading = true
        let res = await request({
            method: 'post',
            url: '/cwgl/psuproject/savefwfinvoice',
            data: form
        })
        if(+res.issuccess === 1){
          this.$message.success('确认成功')
          this.getFwfInfo()
          this.kpflg = false
          this.dialogVisible = false
          return
        }
        this.loading = false
      },
      async setfile (path) {
        this.psu.psufeepayurl = path.replace(this.uploadAddr, '')
      },
      async save () {
        this.btnLoading = true
        this.psu.psufewreceive  = this.radio
        this.psu.psuconfirmfeeuserid = this.$store.getters.loginUser.userid
        this.psu.psuconfirmfeeamt = utils.delcommafy(this.psu.psuconfirmfeeamt)
        let data = await request({
          url: '/cwgl/psuFwf/saveFwfcon',
          method: "post",
          data: this.psu
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('服务费确认成功')
        } else {
          this.$message.error('服务费确认失败')
        }
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuFwfconIndex'})
      },
      inputMoney (el, name) {
        let val = utils.delcommafy(el.target.value)
        var reg = /^[0-9]+.?[0-9]*$/
        if ((reg.test(val))) {
          this.psu[name] = utils.getInputValue(el)
        }
      },
      async ServiceFeeConfirmation(){
        if(+this.radio === 3){
          this.$message.warning('请先选择是否缴费')
          return
        }
        let msg = ''
        if(!this.check){
          msg = `该用户未缴费,`
        }
        this.loading = true
        let model = {}
        model.psuid = this.psu.psuid
        model.psufewreceive = this.radio
        model.psufewreceiver = this.$store.getters.loginUser.userid
        this.$confirm(`${msg}是否确认?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
        let data = await request({
          url: '/cwgl/psuFwf/ServiceFeeConfirmation',
          method: "post",
          data: model
        })
        if(data.issuccess === 1){
          this.getFwfInfo()
          this.$message.success('审核成功');
          return
        }
          }).catch(() => {
        })
        this.loading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .split-box{
    margin: 11px 0 15px;
    
    
    .split-line{
      margin: 5px;
    }
    .split-name{
      font-weight: bold;
    }
  }
</style>
